import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { useGuideStore } from '@/features/guide/guide.store';

const GuideToggleButton = () => {
  const openGuide = useGuideStore(state => state.openGuide);

  return (
    <Box
      component='button'
      type='button'
      data-tour='help-menu'
      aria-label='Open the weavr Guide'
      onClick={openGuide}
      sx={{
        border: 0,
        bgcolor: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        py: 1,
        mb: 2,
        cursor: 'pointer',
        color: '#000000',
        width: '100%',
        '&:hover': {
          bgcolor: '#CC4E0022'
        }
      }}
    >
      <AutoAwesomeIcon sx={{ width: 28, height: 28 }} />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          textAlign: 'center',
          color: '#000000'
        }}
      >
        Guide
      </Typography>
    </Box>
  );
};

export default GuideToggleButton;
